import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import Chip from '@material-ui/core/Chip';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import copyToClipboard from '../../utils/copyToClipboard';
import { Tooltip } from '@material-ui/core';
import isEmpty from 'lodash/isEmpty';
const Wrapper = styled.div`
  padding: 0 24px;
  height: 100%;
  display: flex;
  justify-content: space-between;
`;
const PolicyWrapper = styled.div`
  padding: 8px;
  width: 48%;
  min-width: 460px;
  height: 580px;
  background: ${props => props.currentPolicy ? '#f3f3f3' : '#ffffff'};
`;
const CurrentPolicyButtonContainer = styled.div`
  padding: 0 8px;
  color: #52a6df;
  &:hover {
    text-decoration: underline;
  }
`;
export const Title = styled.div`
  margin: 0;
  padding: 4px;
  margin: 4px;
  font-family: 'OpenSans-Regular';
  font-size: 17px;
  color: black;
  opacity: 0.9;
`;
const ActionWrapper = styled.div`
  display: flex;
  height: 42px;
  & span {
    cursor: pointer;
    margin: 4px;
    padding: 4px;
    &.icon {
      font-size: 16px;
      &:hover {
        opacity: 0.7;
      }
    }
  }

  &.policy-buttons {
    display: flex;
    justify-content: flex-end;
  }
`;
const StyledPolicyText = styled.span`
  width: 100%;
`;
const PolicyRecommendationWrapper = styled.div`
  margin: 8px;
  box-sizing: border-box;
  overflow-y: auto;
  height: 460px;
  & .MuiPaper-elevation1 {
    box-shadow: none;
  }
  & .MuiAccordion-root {
    &:before {
      background: none;
    }
    border-radius: 5px;
    margin-bottom: 8px;
    &.MuiAccordion-expanded {
      margin-bottom: 8px;
    }
    & .MuiAccordionSummary-root {
      font-weight: 500;
      height: 64px;
      border: 1px solid #c6c6c6;
      border-radius: 5px;
      &.Mui-expanded {
        border-radius: 5px 5px 0 0;
        border-bottom: none;
      }
      & .MuiAccordionSummary-content {
        align-items: baseline;
        & i {
          margin-right: 16px;
        }
      }
    }
    & .MuiAccordionDetails-root {
      border: 1px solid #c6c6c6;
      border-radius: 0 0 5px 5px;
      & pre {
        white-space: pre-wrap;
        width: 100%;
      }
    }
  }
`;
const StyledChip = styled(Chip)`
  && {
    box-sizing: border-box;
    border: 1px solid #b6bfcd;
    border-radius: 14px;
    background-color: #ffffff;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 500;
    margin-right: 10px;
    margin-top: 20px;
  }
`;

const RecommendationAccordion = () => {
  const [isGroupAccordionOpen, setGroupAccordionOpen] = useState(true);
  const [isPermissionAccordionOpen, setPermissionAccordionOpen] = useState(true);
  const [isRoleAccordionOpen, setRoleAccordionOpen] = useState(true);
  const [showCurrentPolicy, setShowCurrentPolicy] = useState(false);
  const [expanded, setExpanded] = React.useState(false);
  const [copied, setCopied] = React.useState(false);
  useEffect(() => {
    copied && setTimeout(() => setCopied(false), 1000);
  }, [copied]);

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const impactResult = useSelector(state => state.accordionData.impactResult);
  const policyData = useSelector(state => state.accordionData.policy);
  let {
    group = [],
    role = []
  } = impactResult || {};
  let {
    policy = []
  } = policyData || {};

  function download(content, fileName, contentType) {
    const a = document.createElement('a');
    const file = new Blob([content], {
      type: contentType
    });
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  const handleDownload = e => {
    e.stopPropagation();

    if (!isEmpty(policy.rightSizedPolicy)) {
      var d = new Date();
      let year = d.getFullYear();
      let month = d.getMonth() + 1;
      let date = d.getDate();
      var dateVal = year + '-' + month + '-' + date;
      download(JSON.stringify(JSON.parse(policy.rightSizedPolicy)), dateVal + '.json', 'application/json');
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(PolicyWrapper, null, /*#__PURE__*/React.createElement(Title, null, "Recommended Action"), /*#__PURE__*/React.createElement(ActionWrapper, null, /*#__PURE__*/React.createElement(CurrentPolicyButtonContainer, {
    onClick: () => setShowCurrentPolicy(!showCurrentPolicy)
  }, showCurrentPolicy ? 'Hide' : 'Show', " Current Policy")), /*#__PURE__*/React.createElement(PolicyRecommendationWrapper, null, group.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    onClick: () => setGroupAccordionOpen(!isGroupAccordionOpen)
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "panel1a-content",
    id: "recommended-policy",
    className: "header"
  }, /*#__PURE__*/React.createElement("span", null, !isGroupAccordionOpen ? /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-up"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-down"
  }), ' '), /*#__PURE__*/React.createElement("span", null, "Remove group(s) that have not been used in the last 90 days")), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: "body"
  }, /*#__PURE__*/React.createElement("pre", null, group.map((val, index) => {
    return /*#__PURE__*/React.createElement(StyledChip, {
      key: index,
      label: val
    });
  }))))) : null, role.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    onClick: () => setRoleAccordionOpen(!isRoleAccordionOpen)
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "panel1a-content",
    id: "recommended-policy",
    className: "header"
  }, /*#__PURE__*/React.createElement("span", null, !isRoleAccordionOpen ? /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-up"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-down"
  }), ' '), /*#__PURE__*/React.createElement("span", null, "Remove role(s) that have not been used in the last 90 days")), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: "body"
  }, /*#__PURE__*/React.createElement("pre", null, role.map((val, index) => {
    return /*#__PURE__*/React.createElement(StyledChip, {
      key: index,
      label: val
    });
  }))))) : null, policy.rightSizedPolicy && policy.rightSizedPolicy.length && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    onClick: () => setPermissionAccordionOpen(!isPermissionAccordionOpen)
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "panel1a-content",
    id: "recommended-policy",
    className: "header"
  }, /*#__PURE__*/React.createElement("span", null, !isPermissionAccordionOpen ? /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-up"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-down"
  }), ' '), /*#__PURE__*/React.createElement(StyledPolicyText, null, "Replace policy that have not been used in the last 90 days"), /*#__PURE__*/React.createElement(ActionWrapper, {
    className: "policy-buttons"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Download Recommended Policy"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon",
    onClick: handleDownload
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-download"
  }))), /*#__PURE__*/React.createElement(Tooltip, {
    title: copied ? 'Copied' : 'Copy Recommended Policy'
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon",
    onClick: e => {
      e.stopPropagation();

      if (!copied && !isEmpty(policy.rightSizedPolicy)) {
        copyToClipboard(JSON.stringify(JSON.parse(policy.rightSizedPolicy), null, 4));
        setCopied(true);
      }
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "far fa-copy"
  }))))), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: "body"
  }, /*#__PURE__*/React.createElement("pre", null, !isEmpty(policy.rightSizedPolicy) && JSON.stringify(JSON.parse(policy.rightSizedPolicy), null, 4))))))), showCurrentPolicy && /*#__PURE__*/React.createElement(PolicyWrapper, {
    currentPolicy: true
  }, /*#__PURE__*/React.createElement(Title, null, "Current Policy"), /*#__PURE__*/React.createElement(ActionWrapper, null), /*#__PURE__*/React.createElement(PolicyRecommendationWrapper, null, !isEmpty(policy.oldPolicies) && policy.oldPolicies.map((oldPolicy, index) => /*#__PURE__*/React.createElement(Accordion, {
    TransitionProps: {
      unmountOnExit: true
    },
    key: oldPolicy.oldPolicyName,
    expanded: expanded === index,
    onChange: handleChange(index)
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, expanded === index ? /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-up"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "fas fa-chevron-down"
  }), ' ', oldPolicy.oldPolicyName), /*#__PURE__*/React.createElement(AccordionDetails, null, /*#__PURE__*/React.createElement("pre", null, !isEmpty(oldPolicy) ? JSON.stringify(JSON.parse(oldPolicy.oldPolicyValue), null, 4) : ''))))))));
};

export default RecommendationAccordion;